const QueryKeys = {
  AIGradingEligibility: 'AIGradingEligibility',
  AISafetyFailure: 'AISafetyFailure',
  AISafetyReport: 'AISafetyReport',
  Assessments: 'Assessments',
  CompletedStatus: 'CompletedStatus',
  ContentAlertMessages: 'ContentAlertMessages',
  ContentPrograms: 'ContentPrograms',
  ContentReferenceMaterials: 'ContentReferenceMaterials',
  CorrelationCandidates: 'CorrelationCandidates',
  Correlations: 'Correlations',
  DevDocsManifest: 'DevDocsManifest',
  GlossaryTerms: 'GlossaryTerms',
  Icons: 'Icons',
  Images: 'Images',
  ImageModels: 'ImageModels',
  Lessons: 'Lessons',
  Licenses: 'Licenses',
  ModelCorrelations: 'ModelCorrelations',
  ModelResourceTemplates: 'ModelResourceTemplates',
  ModelResources: 'ModelResources',
  ModelReferenceMaterials: 'ModelReferenceMaterials',
  Mutations: {
    Delete: 'Delete',
    Patch: 'Patch',
    Post: 'Post',
  },
  ProgramStates: 'ProgramStates',
  LessonGuides: 'LessonGuides',
  ProgramUnits: 'ProgramUnits',
  Unit: 'Unit',
  Programs: 'Programs',
  ReferenceMaterial: 'ReferenceMaterial',
  ReferenceMaterialFilterTags: 'ReferenceMaterialFilterTags',
  ReferenceMaterials: 'ReferenceMaterials',
  ScoresData: 'ScoresData',
  Sections: 'Sections',
  Slide: 'Slide',
  SlideFrames: 'SlideFrames',
  SlideShowQuestionGroups: 'SlideShowQuestionGroups',
  SlideShows: 'SlideShows',
  StandardCorrelations: 'StandardCorrelations',
  Standards: 'Standards',
  StandardsReport: 'StandardsReport',
  StandardsReportQuestionScores: 'StandardsReportQuestionScores',
  States: 'States',
  SubscriberSearch: 'SubscriberSearch',
  SubscriberVersions: 'SubscriberVersions',
  SystemStatus: 'SystemStatus',
  ThemeCss: 'ThemeCss',
  UseClassrooms: 'useClassrooms',
  UseProfessionalDevelopmentResults: 'useProfessionalDevelopmentResults',
  UseStyleSheets: 'useStyleSheets',
  UseTeacherNotes: 'UseTeacherNotes',
  UseThemes: 'useThemes',
  UseThreeDModel: 'useThreeDModel',
  UserSearch: 'UserSearch',
  UserSearchDetail: 'UserSearchDetail',
  UserSearchSavedWork: 'UserSearchSavedWork',
  Versions: 'Versions',
} as const;

export default QueryKeys;
